import ContactLeadsContainer from "../../container/admin/contact-leads";

const ContactLeads = () => {
    return <ContactLeadsContainer />;
};

export default ContactLeads;